import axios from "axios";

const serviceAlertBaseUrl = process.env.VUE_APP_API_URL_SERVICE_ALERT;

const httpClient = axios.create({
  headers: {
    "Content-Type": "application/json"
  },
  timeout: 120000
});

httpClient.interceptors.response.use(
  response => response,
  error => errorInterceptor(error)
);

const errorInterceptor = error => {
  if (error && !error.response) {
    if (error.code === "ECONNABORTED") {
      error.response = {
        data: {
          isSucess: false,
          error:
            "Request has timed out. Please try again, if issue persists then call our support team"
        }
      };
    }
  }
  return Promise.reject(error);
};



export default {
  healthCheck() {
    return httpClient.get(baseUrl);
  },
  getServiceCatalogs() {
    return httpClient.get(`${serviceAlertBaseUrl}service-catalogs`);
  },
  subscriptionVerification(token) {
    return httpClient.get(`${serviceAlertBaseUrl}verification/${token}`);
  },
  unsubscribeVerification(token) {
    return httpClient.get(`${serviceAlertBaseUrl}unsubscribe/${token}`);
  },
  createSubscription(payload) {
    return httpClient.post(`${serviceAlertBaseUrl}subscribe`, payload);
  }
};
